import React from 'react'
import { cubicBezier, motion } from 'framer-motion'
import { Box, Flex, styled, Text } from '@chilipiper/design-system'
import { Avatar } from '@chilipiper/design-system/src/new'
import { useMessageFeedContext } from '../chat-widget/MessageFeedContext'
import { StyledAvatarImage } from './styles'

const easing = cubicBezier(0.42, 0, 0.58, 1)

export const TypingAnimation = () => {
  const { channel } = useMessageFeedContext()
  return (
    <motion.div
      initial={{ height: 0 }}
      animate={{ height: 'auto' }}
      transition={{ duration: 0.35, ease: easing }}
    >
      <Flex flexDirection='column' alignItems='flex-start' gap='2xs'>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ delay: 0.35, duration: 0.15, ease: easing }}
        >
          <TypingAnimationCore />
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.35, duration: 0.15, ease: easing }}
        >
          <Flex gap='2xs'>
            {channel?.type === 'assignee' ? (
              <Avatar
                id={channel.id}
                name={channel.fullName ?? ''}
                image={channel.avatar}
                size={4}
              />
            ) : typeof channel?.avatar === 'string' ? (
              <StyledAvatarImage size='16px' borderRadius='4px' src={channel?.avatar} alt='' />
            ) : (
              <Box w='16px' h='16px'>
                {channel?.avatar}
              </Box>
            )}
            <Text textStyle='detail-m' color='fg/moderate'>
              {channel?.fullName}
            </Text>
          </Flex>
        </motion.div>
      </Flex>
    </motion.div>
  )
}

const TypingAnimationCore = () => (
  <Flex bg='bg/section-emphasis' px={4} h='44px' gap={1} borderRadius={16} alignItems='center'>
    <StyledDot />
    <StyledDot />
    <StyledDot />
  </Flex>
)

const StyledDot = styled(Box)`
  height: 0.25rem;
  width: 0.25rem;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors['fg/major']};
  animation:
    jump 1.5s ease-in-out infinite,
    pulse 1.5s ease-in-out infinite;

  :nth-of-type(2) {
    animation-delay: 0.15s;
  }

  :nth-of-type(3) {
    animation-delay: 0.3s;
  }

  @keyframes jump {
    0%,
    40%,
    100% {
      transform: translateY(0);
    }
    20% {
      transform: translateY(-6px);
    }
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    66% {
      opacity: 0.25;
    }
  }
`
